import axios from 'src/utils/axios';
import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName) => {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert the data to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Generate a binary string representation of the workbook
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // Create a Blob from the binary string
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  // Create a link element
  const link = document.createElement('a');

  // Set the download attribute with the desired file name
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;

  // Append the link to the body
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Remove the link from the document
  document.body.removeChild(link);
}


// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr);
  }
  setUserSessionFromLocale();
  return localStorage.getItem('user');
};


export const mergeArrayWithObject = (arr, obj) => { arr && arr.map((t) => (t.id === obj.id ? obj : t)); return arr; };
export const modifyObject = (obj, name, value) => { obj[0][name] = value; return obj; };
export const modifyAnObjectInArray = (arr, id, name, value) => (arr.map((el) => (el.id === id ? { ...el, [name]: value } : el)));

// { arr && arr.map(t => t.id === id ? Object.assign(t, t.map(el => el.key === name ? value : el)) : t); return arr; }



export const moneyFormat = (Price, CountryCode, Currency) =>
  new Intl.NumberFormat(CountryCode, {
    style: 'currency',
    currency: Currency,
    minimumFractionDigits: 2
  })
    .formatToParts(Price)
    .map(p => (p.type != 'literal' && p.type != 'currency' ? p.value : ''))
    .join('');


export const setUserMobile = (MobileNumber) => {
  const ChangeuserStr = sessionStorage.getItem('user');
  const ChangeuserStr1 = JSON.parse(ChangeuserStr);
  ChangeuserStr1.MobileNumber = MobileNumber;

  sessionStorage.removeItem('user');
  sessionStorage.setItem('user', JSON.stringify(ChangeuserStr1));

  localStorage.removeItem('user');
  localStorage.setItem('user', JSON.stringify(ChangeuserStr1));
};
export const setCounting = (value) => {
  const ChangeuserStr = sessionStorage.getItem('user');
  const ChangeuserStr1 = JSON.parse(ChangeuserStr);
  ChangeuserStr1.Counting = value;

  sessionStorage.removeItem('user');
  sessionStorage.setItem('user', JSON.stringify(ChangeuserStr1));

  localStorage.removeItem('user');
  localStorage.setItem('user', JSON.stringify(ChangeuserStr1));
};
// return the token from the session storage
export const getToken = () => sessionStorage.getItem('token') || null;

export const getTokenWs = () => sessionStorage.getItem('tokenWs') || null;

export const getIpAddress = () => localStorage.getItem('IpAddress') || null;
export const getSepetAdet = () => localStorage.getItem('SepetAdet') || null;

export const setIpAddress = (IpAddress) => { // T_ARTEMIS kontrolü yaparken tokensız gitmesin diye eklendi. Okta sonrası kaldırılacak.
  localStorage.setItem('IpAddress', IpAddress);
};

export const setSepetAdet = (Adet) => { // T_ARTEMIS kontrolü yaparken tokensız gitmesin diye eklendi. Okta sonrası kaldırılacak.
  localStorage.removeItem('SepetAdet');
  localStorage.setItem('SepetAdet', Adet);
};


// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('tokenWs');
  sessionStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenWs');
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
};

// set the token and user from the session storage
export const setUserSession = (token, tokenWs, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('lastLogin', new Date());
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('user', JSON.stringify(user));
};

// set the token and user from the session storage
export const setSessionToken = (token, tokenWs) => { // T_ARTEMIS kontrolü yaparken tokensız gitmesin diye eklendi. Okta sonrası kaldırılacak.
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
};

export const setUserSessionFromLocale = () => {
  const lastLogin = localStorage.getItem('lastLogin');
  const token = localStorage.getItem('token');
  const tokenWs = localStorage.getItem('tokenWs');
  const user = localStorage.getItem('user');
  if (lastLogin === null || token === null || user === null) {
    return false;
  }
  const now = new Date();
  const ll = new Date(lastLogin);
  if (now.getYear() === ll.getYear() && now.getMonth() === ll.getMonth() && now.getDate() === ll.getDate()) {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('tokenWs', tokenWs);
    sessionStorage.setItem('user', user);
    return true;
  }
  return false;
};


// set Language preference
export const setLanguage = (lang) => {
  sessionStorage.removeItem('language');
  sessionStorage.setItem('language', lang);
};

// get Language preference, if it is not set, return english as default.
export const getLanguage = () => sessionStorage.getItem('language') || 'tr';

export const getKoordinat = (Param) => sessionStorage.getItem(Param) || null;

export const setKoordinat = (Enlem, Boylam,) => {
  sessionStorage.removeItem('Enlem');
  sessionStorage.removeItem('Boylam');
  sessionStorage.setItem('Enlem', Enlem);
  sessionStorage.setItem('Boylam', Boylam);
};

export var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};
function success(pos) {
  const crd = pos.coords;
  setKoordinat(crd.latitude, crd.longitude);
}

function error(err) {
  console.warn(`ERROR(${err.code}): ${err.message}`);

  window.location.href = `${window.location.origin}/`;
}

export function GetLocation() {
  return navigator.geolocation.getCurrentPosition(success, error, options);
}


export const sendLocation = (pos) => {
  const user = getUser();
  const now = new Date();
  if (user === undefined || user === null) {
    return;
  }
  const data = {
    ServiceShopId: user.ServiceShopId,
    TechnicianId: user.TechnicianId,
    Latitude: pos.coords.latitude,
    Longitude: pos.coords.longitude,
    CreateDate: `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
  };
  const config = {
    headers: { 'Content-Type': 'application/json,' }
  };

  axios.post('/Location/SetLocation', data, config);
};

export const distinct = (a) => {
  a.forEach((chunk, idx) => { a[idx] = JSON.stringify(chunk); });
  a = [...new Set(a)];
  a.forEach((chunk, idx) => { a[idx] = JSON.parse(chunk); });
  return a;
};

// string comparison
export const sc = (str, key) => (str || '').toString().toLocaleLowerCase(localStorage.i18nextLng_normalized).indexOf((key || '').toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)) !== -1;

// return the plate from the session storage
export const getPlate = () => localStorage.getItem('plate') || '';

// update plate.
export const setPlate = (p) => {
  localStorage.removeItem('plate');
  localStorage.setItem('plate', p);
};

// return the tour open from the local storage
export const getTourOpen = () => (localStorage.getItem('tourOpen') !== 'false');

// update tour open.
export const setTourOpen = () => {
  localStorage.removeItem('tourOpen');
  localStorage.setItem('tourOpen', 'false');
};

// return the last phone and sms code
export const getLastSms = () => [localStorage.getItem('SMS_TEL') || '', localStorage.getItem('SMS_KOD') || ''];

// update tour open.
export const setLastSms = (tel, phone) => {
  localStorage.removeItem('SMS_TEL');
  localStorage.removeItem('SMS_KOD');
  localStorage.setItem('SMS_TEL', tel);
  localStorage.setItem('SMS_KOD', phone);
};


export const openBlob = (blob, fileName = 'ArtemisFile') => {
  const fileURL = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = fileURL;
  a.target = '_self';
  a.download = fileName;
  a.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL);
  }, 5000);
};


export const generateCode = (length) => {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const handleLogout = () => {
  // const user = getUser();
  // if (user === undefined || user === null) {
  //   return;
  // }
  removeUserSession();
  sessionStorage.clear();
  localStorage.clear();
  // window.location.href = 'http://logintest.arcelik.com/';
};

export const handleLogoutMain = () => {
  handleLogout();
};

export const monthsTr = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
